import { useEffect } from "react";
import Prism from "prismjs";

export default (...dependencies) => {
  useEffect(() => {
    Prism.highlightAll();
    // eslint-disable-next-line
  }, dependencies);
};
